import React from 'react';
import { useGetProfileActiveLimitOrders } from 'hooks/api/portfolio';
import MetricItem from 'components/MetricCard';

import messages from './IndependentIraActiveLimitOrders.messages';

type IndependentIraActiveLimitOrdersProps = {
  enableToFetch?: boolean;
};

const IndependentIraActiveLimitOrders: React.FC<IndependentIraActiveLimitOrdersProps> = ({
  enableToFetch = true,
}) => {
  const { isLoading, data } = useGetProfileActiveLimitOrders(enableToFetch);

  return (
    <MetricItem
      label={messages.label}
      amount={data?.limitOrdersLength}
      isLoading={isLoading}
      isUsd={false}
    />
  );
};

export default IndependentIraActiveLimitOrders;
